import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './PanelSidebarBottom.less';
import { translate } from '@portal/services/i18n';
import { AuthActions } from '@portal/actions';
import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';

const PanelSidebarBottom = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const onUserLogout = () => {
    dispatch(AuthActions.logout());
  };

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.SIDEBAR,
    });
  }, [location]);

  return (
    <div className="panel-sidebar-bottom" onClick={() => onUserLogout()}>
      <div className="panel-sidebar-bottom__popover">
        <span>
          <img
            className="panel-sidebar-bottom__icon__image"
            src="/assets/svg/panel-sidebar/ic_logout.svg"
            alt="settings"
          />
        </span>
        <span className="panel-sidebar-bottom__title">
          {translate('APPLICATION.LOGOUT')}
        </span>
      </div>
    </div>
  );
};

export default PanelSidebarBottom;
